"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityAirport = function SvgAmenityAirport(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M291.4 511.3c0 12.8-9.6 22.4-19.1 19.2H170c-9.6 0-19.2-6.4-19.2-19.2 0-9.6 6.4-19.2 19.2-19.2h102.2c9.6 0 19.2 6.4 19.2 19.2zm572.1 114.9H655.8l-32 70.3h28.8c9.6 0 19.2 6.4 19.2 19.2v92.7c0 9.6-6.4 19.2-19.2 19.2h-89.5l-76.7 172.6c-3.2 6.4-9.6 12.8-16 12.8l-70.3 9.6c-6.4 0-19.2 3.2-22.3.1-3.2-3.2-6.4-9.6-6.4-16V629.6H230.8l-67.1 147c-3.2 6.4-9.6 12.8-16 12.8l-28.8 3.2c-6.4 0-12.8-3.2-16-6.4-3.2-3.2-6.4-9.6-6.4-16V604C71 581.6 55 552.9 55 517.7v-9.6c0-35.2 15.9-67.1 41.4-86.2V255.7c0-6.4 3.2-9.6 6.4-12.8 3.2-6.4 9.6-6.4 16-6.4l32 3.2c6.4 0 12.8 6.4 16 12.8l67.1 147h140.6V22.4c0-6.4 3.2-12.8 6.4-16 3.2-6.4 9.6-6.4 16-6.4l70.3 16c6.4 0 12.8 6.4 16 12.8l76.6 172.3h89.5c9.6 0 19.2 6.4 19.2 19.2V313c0 9.6-6.4 19.2-19.2 19.2h-28.8l32 70.3h207.9C921.1 399.4 969 447.3 969 508v9.6c3.1 60.7-44.8 108.6-105.5 108.6zM582.2 233.3l22.4 51.1h25.6v-51.1h-48zM416.1 399.4h191.7L454.4 51.1l-38.3-6.4v354.7zm-278.1 0h25.6l25.5-3.2L138 287.6v111.8zm51.2 223.7H138V735l51.2-111.9zm418.6 0H416v354.7l35.2-3.2 156.6-351.5zM601.4 735L579 786.1h51.2V735h-28.8zm326-230.1c0-38.3-28.8-67.1-67.1-67.1H166.8c-35.1 0-70.3 28.8-70.3 67.1v9.6c0 38.3 32 67.1 70.3 67.1h693.5c38.3 0 67.1-28.8 67.1-67.1v-9.6z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityAirport, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;